import React, { useEffect, useState } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useDispatch, useSelector } from 'react-redux';
import { updateCurrentPerformance } from '../../redux/graphs';
import Result from '../Result';

const CurrentPerformance = () => {
  const dispatch = useDispatch();

  const current_performance = useSelector((state) => state.graphs.current_performance);
  const [options, setOptions] = useState([]);
  // - - - - - - - - - - - - - - - - - - - - - - - - -

  useEffect(() => {
    dispatch(
      updateCurrentPerformance()
    );
  }, []);

  useEffect(() => {
    setOptions (
      {
        chart: {
          type: 'bar'
        },
        title: {
          text: 'Current Performance',
          align: 'left'
        },
        subtitle: {
          text: "This measures your own view of how well you've handled stress in your work over the last month or two",
          align: 'left'
        },
        xAxis: {
          categories: current_performance.x_labels,
          title: {
            text: null
          },
          gridLineWidth: 1,
          lineWidth: 0
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Performance Score',
            align: 'high'
          },
          labels: {
            overflow: 'justify'
          },
          gridLineWidth: 0
        },
        plotOptions: {
          bar: {
            borderRadius: '50%',
            dataLabels: {
              enabled: true
            },
            groupPadding: 0.1
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -40,
          y: 80,
          floating: true,
          borderWidth: 1,
          backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
          shadow: true
        },
        credits: {
          enabled: false
        },
        series: [
          {
            name: 'Performance Score',
            data: current_performance.data
          }
        ]
      }
    );
  }, [current_performance]);

  // ==================================================
  // ==================================================
  return(
    <div>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />

      <Result 
        result_text={"You currently view your overall mental performance as average"}
      />
    </div>
  );
};

export default CurrentPerformance;